import React from 'react';

interface ConversationProps {
  id: string;
  time: Date;
  selected?: boolean;
  onClick?: () => void;
}

const Conversation: React.FC<ConversationProps> = ({ id, time, selected, onClick }) => {
  return (
    <div
      className={`conversation-bubble${selected ? ' selected' : ''}`}
      onClick={onClick}
      style={{
        cursor: 'pointer',
        padding: '10px 16px',
        borderRadius: '16px',
        background: selected ? 'var(--gradient-main)' : 'rgba(255,255,255,0.08)',
        color: selected ? '#ffffff' : 'var(--text-secondary)',
        marginBottom: '10px',
        boxShadow: selected ? '0 2px 8px rgba(0,0,0,0.10)' : 'none',
        border: selected ? '2px solid var(--orange-main)' : '1px solid rgba(0,0,0,0.04)',
        transition: 'all 0.2s',
        fontSize: '0.97rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <div style={{ fontWeight: 700, fontSize: '1.02em', marginBottom: 2 }}>#{id}</div>
      <div style={{ fontSize: '0.85em', opacity: 0.8 }}>{time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
    </div>
  );
};

export default Conversation; 